import type { Message } from './use-chat';

/** Keep loaded history only when the refreshed tail proves the windows overlap. */
export function refreshHistoryWindow(current: Message[], latest: Message[], olderCursor: string | null,
  previousCursor: string | null, preserveEarlier: boolean): { messages: Message[]; olderCursor: string | null } {
  if (!preserveEarlier || latest.length === 0) return { messages: latest, olderCursor };
  const first = latest[0].finalId ?? latest[0].id;
  const overlap = current.findIndex(message => (message.finalId ?? message.id) === first);
  if (overlap < 0) return { messages: latest, olderCursor };
  return { messages: [...current.slice(0, overlap), ...latest], olderCursor: previousCursor };
}

export function prependHistoryWindow(current: Message[], earlier: Message[]): Message[] {
  const ids = new Set(current.flatMap(message => [message.id, message.finalId]).filter(Boolean));
  return [...earlier.filter(message => !ids.has(message.finalId ?? message.id)), ...current];
}

/** Warm navigation stores one bounded page, without replaying streaming animations. */
export function cachedHistoryWindow(messages: Message[]): Message[] {
  return messages.slice(-40).map(message => message.animate ? { ...message, animate: false } : message);
}
